import React from 'react';
import { IProps } from './interfaces';

const KrBike: React.FC<IProps> = ({
  size = 32,
  color = '#FF6900',
  className,
}) => {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25 12.69C24.34 12.69 23.7 12.79 23.1 12.97L21.12 9C20.81 7.89 19.68 6 17.28 6C16.78 6 16.38 6.4 16.38 6.9C16.38 7.4 16.78 7.8 17.28 7.8C18.56 7.8 19.11 8.74 19.31 9.25L17.79 11.93H9.72L9.39 11H10.31C10.81 11 11.21 10.6 11.21 10.1C11.21 9.6 10.81 9.2 10.31 9.2H6.07C5.57 9.2 5.17 9.6 5.17 10.1C5.17 10.6 5.57 11 6.07 11H7.47L8.14 12.88C7.64 12.76 7.12 12.69 6.59 12.69C2.95 12.69 0 15.65 0 19.28C0 22.91 2.96 25.87 6.59 25.87C9.94 25.87 12.7 23.36 13.12 20.13H15.05L18.8 13.73H18.82L20.22 11.26L21.45 13.73C19.62 14.9 18.39 16.95 18.39 19.29C18.39 22.93 21.35 25.88 24.98 25.88C28.61 25.88 31.57 22.92 31.57 19.29C31.57 15.66 28.61 12.7 24.98 12.7L25 12.69ZM6.58 24.08C3.94 24.08 1.79 21.93 1.79 19.29C1.79 16.65 3.94 14.5 6.58 14.5C8.9 14.5 10.84 16.15 11.28 18.34H6.15C5.65 18.34 5.25 18.74 5.25 19.24C5.25 19.74 5.65 20.14 6.15 20.14H11.29C10.89 22.38 8.93 24.08 6.58 24.08ZM14.02 18.34H13.1C12.82 16.41 11.7 14.75 10.13 13.74H16.71L14.02 18.34ZM25 24.08C22.36 24.08 20.21 21.93 20.21 19.29C20.21 17.66 21.03 16.22 22.28 15.36L24.66 20.12C24.82 20.44 25.14 20.62 25.47 20.62C25.61 20.62 25.74 20.59 25.87 20.52C26.31 20.3 26.49 19.76 26.27 19.31L23.93 14.63C24.28 14.55 24.64 14.5 25.01 14.5C27.65 14.5 29.8 16.65 29.8 19.29C29.8 21.93 27.65 24.08 25.01 24.08H25Z"
        fill={color}
      />
    </svg>
  );
};

export default KrBike;
